export function _min(...values) {
    if (values.length === 1 && Array.isArray(values[0])) {
        return Math.min(...values[0]);
    } else if (values.length === 1 && typeof values[0] === 'object') {
        return Math.min(...Object.values(values[0]));
    }
    return Math.min(...values);
}

export function _max(...values) {
    if (values.length === 1 && Array.isArray(values[0])) {
        return Math.max(...values[0]);
    } else if (values.length === 1 && typeof values[0] === 'object') {
        return Math.max(...Object.values(values[0]));
    }
    return Math.max(...values);
}
